import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';

const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del usuario
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login


class SidebarVicerrectoradoAcad extends Component {

    componentDidMount() {
        // Get que devuelve los datos del usuario especificando un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const administrativo = res.data;
                this.setState({ administrativo });

                cookie.set('nombres', administrativo.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', administrativo.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (

            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Personal de Vicerrectorado Académico</p>
                        </div>

                        <Link to="/vicerrectoradoacad" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal
                        </Link>

                        {/* Matrículas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculasVicerAcad"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Matrículas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseMatriculasVicerAcad">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/vicerrectoradoacad/listcoordinaciones" className="nav-sub-link">
                                        Lista Coordinaciones
                                    </Link>
                                    <Link to="/vicerrectoradoacad/cantidadmatri" className="nav-sub-link">
                                        Cantidad de Matriculados
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Asignaturas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseAsignaturasVicerAcad"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i>
                                    Asignaturas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseAsignaturasVicerAcad">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/vicerrectoradoacad/AsignaturasEstCarreraCicloAcad"
                                        className="nav-sub-link"
                                    >
                                        Asignaturas Carrera Ciclo
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Asignaturas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseCreditoExtraVicerAcad"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i>
                                    Créditos Extra
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseCreditoExtraVicerAcad">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/vicerrectoradoacad/GestionCreditosExtra"
                                        className="nav-sub-link"
                                    >
                                        Gestión de Créditos Extra
                                    </Link>
                                    <Link
                                        to="/vicerrectoradoacad/GestionEstudianteCreditos"
                                        className="nav-sub-link"
                                    >
                                        Matrícula de Estudiantes en Créditos
                                    </Link>
                                    <Link
                                        to="/vicerrectoradoacad/GestionDocenteCreditos"
                                        className="nav-sub-link"
                                    >
                                        Asignación de Docentes a Créditos
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Perfil */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfilVicerAcad"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePerfilVicerAcad">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/vicerrectoradoacad/VerPerfilVicerrAcad" className="nav-sub-link">
                                        Ver Perfil
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Planes */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePlanesVicerAcad"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-file-alt me-2"></i>
                                    Planes
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePlanesVicerAcad">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/vicerrectoradoacad/GestionPlanes" className="nav-sub-link">
                                        Gestión de Planes
                                    </Link>
                                    <Link to="/vicerrectoradoacad/GestionEjes" className="nav-sub-link">
                                        Gestión de Ejes
                                    </Link>
                                    <Link to="/vicerrectoradoacad/GestionEjesPlan" className="nav-sub-link">
                                        Ejes de Plan
                                    </Link>
                                    <Link to="/vicerrectoradoacad/GestionObjIndicador" className="nav-sub-link">
                                        Gestión de Objetivos
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Evaluaciones Docentes */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseEvalDocentesVicerAcad"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-check-circle me-2"></i>
                                    Evaluaciones Docentes
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseEvalDocentesVicerAcad">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/vicerrectoradoacad/GestionEvalDocentes"
                                        className="nav-sub-link"
                                    >
                                        Gestión de Evaluaciones
                                    </Link>
                                    <Link
                                        to="/vicerrectoradoacad/GestionPreguntasEval"
                                        className="nav-sub-link"
                                    >
                                        Gestión de Preguntas
                                    </Link>
                                    <Link
                                        to="/vicerrectoradoacad/HeteroEvalAsignaturasDocentePeriodo"
                                        className="nav-sub-link"
                                    >
                                        Heteroevaluación
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:<br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}
export default withRouter(SidebarVicerrectoradoAcad);